import * as React from "react";
import {Alert, Container, Form, Button, Card} from "react-bootstrap";
import {Formik} from "formik";
import {connect} from "react-redux";
import * as Yup from "yup";
import {loginUser, acceptInvite} from "../../redux/user/action";
import withRequestState from "../../components/WithRequestState";
import { LOGIN_USER_REQUEST, ACCEPT_INVITE_REQUEST_SUCCESS } from "../../redux/user/reducer";
import { RequestStateProps } from "../../interfaces/RequestState";
import { useHistory, withRouter, RouteComponentProps, Link } from "react-router-dom";
import {resetRequestState} from "../../redux/requests/action";


interface IProps {
    loginUser: (username : string, password : string) => void;
    resetRequestState: (types : string[]) => void;
    acceptInvite: (email : string, password : string, inviteCode : string) => void;
}

interface IState {
    register: boolean;
}

interface Params {
    code: string;
}

class Invitation extends React.Component<IProps & RequestStateProps & RouteComponentProps<Params>, IState> {

    get inviteId() : string {
        const {code} = this.props.match.params;
        return code;
    }

    constructor(props){
        super(props);
        this.state = {
            register: false
        }
    }

    submit(email : string, password : string){
        this.props.acceptInvite(email, password, this.inviteId);
    }

    componentWillUnmount(){
        this.props.resetRequestState([ACCEPT_INVITE_REQUEST_SUCCESS]);
    }

    componentDidUpdate(){    
        if (this.props.isSuccessful){
            this.props.history.push("/sites");
        }
    }

    render(){
        return (
            <Container>
                
                <Alert variant="primary" className="mt-4">
                    Please login to accept the invite...
                </Alert>

                <Card>

                    <Card.Header>
                        <h1>Invitation</h1>
                    </Card.Header>

                    <Card.Body>                       

                        <Formik
                            initialValues={{
                                email: "",
                                password: "",
                                repassword: ""
                            }}
                            validationSchema={
                                Yup.object().shape({
                                    email: Yup.string().email().required(),
                                    password: Yup.string().required(),
                                    repassword: this.state.register ? Yup.string().required().oneOf([Yup.ref("password")], "Passwords don't match").min(8)
                                        : Yup.string()
                                })
                            }
                            onSubmit={({email, password}) => {
                                this.submit(email, password);    
                            }}
                        >
                            {props => (
                                <Form onSubmit={props.handleSubmit} noValidate>

                                    <Form.Group>

                                        <Form.Label>Email</Form.Label>
                                        <Form.Control 
                                            type="text"
                                            placeholder="example@abc.com"
                                            name="email"
                                            value={props.values.email}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            required={true}
                                            isInvalid={!!props.errors.email}
                                        />

                                        <Form.Control.Feedback type="invalid">
                                            {props.errors.email}
                                        </Form.Control.Feedback>


                                    </Form.Group>

                                    <Form.Group>

                                        <Form.Label>Password</Form.Label>
                                        <Form.Control 
                                            type="password"
                                            placeholder="Password"
                                            name="password"
                                            value={props.values.password}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            required={true}
                                            isInvalid={!!props.errors.password}
                                        />

                                        <Form.Control.Feedback type="invalid">
                                            {props.errors.password}
                                        </Form.Control.Feedback>


                                    </Form.Group>

                                    {
                                        this.state.register ? 
                                        <React.Fragment>

                                            <Form.Group>

                                                <Form.Label>Confirm password</Form.Label>
                                                <Form.Control 
                                                    type="password"
                                                    placeholder="repassword"
                                                    name="repassword"
                                                    value={props.values.repassword}
                                                    onChange={props.handleChange}
                                                    onBlur={props.handleBlur}
                                                    required={true}
                                                    isInvalid={!!props.errors.repassword}
                                                />

                                            <Form.Control.Feedback type="invalid">
                                                {props.errors.repassword}
                                            </Form.Control.Feedback>

                                            </Form.Group>
                                        </React.Fragment> : null
                                    }

                                    {
                                        !props.isValid ? 
                                            <Alert variant="danger">
                                                Incorrect, please try again.
                                            </Alert> : null
                                    }

                                    <Button variant="primary" type="submit">{this.state.register ? "Register" : "Login"}</Button>

                                    <Alert variant="info" className="mt-3 d-block d-sm-flex align-items-center">
                                        <i className="material-icons pr-2">info</i>
                                        Don't have an account, click <Button variant="link" className="px-1" onClick={() => this.setState({register: true})}>here</Button> to register
                                    </Alert>

                                </Form>
                            )}
                        </Formik>

                    </Card.Body>

                </Card>
               


            </Container>
        )
    }

}


export default withRouter(connect(
    null,
    ({
        loginUser,
        resetRequestState,
        acceptInvite
    })
)(withRequestState(Invitation, [ACCEPT_INVITE_REQUEST_SUCCESS])));